import React, { createContext, useContext, useState, useCallback } from 'react'

interface AdminUser { id: string; email: string; firstName: string; lastName: string; role: string }
interface AuthCtx { user: AdminUser | null; token: string | null; login: (t: string, u: AdminUser) => void; logout: () => void; isAuthenticated: boolean }

const AuthContext = createContext<AuthCtx | null>(null)

export function AuthProvider ({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('inv_admin_token'))
  const [user, setUser] = useState<AdminUser | null>(() => {
    try { const u = localStorage.getItem('inv_admin_user'); return u ? JSON.parse(u) : null } catch { return null }
  })

  const login = useCallback((t: string, u: AdminUser) => {
    localStorage.setItem('inv_admin_token', t); localStorage.setItem('inv_admin_user', JSON.stringify(u))
    setToken(t); setUser(u)
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('inv_admin_token'); localStorage.removeItem('inv_admin_user')
    setToken(null); setUser(null)
  }, [])

  return <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated: !!token }}>{children}</AuthContext.Provider>
}

export function useAuth () {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth outside AuthProvider')
  return ctx
}
